










































import { Component, Watch, Vue } from 'vue-property-decorator';
import { TSyncableTableWithDelay } from '@/plugins/podolib/services/entities/mixins/entities';
import { Severity } from '@sentry/types';

@Component
export default class ElementSearchPatient extends Vue {
  private patients = [];
  private selectedPatient: string | null = null;
  private search = {
    fields: ['infos.firstName', 'infos.lastName', 'infos.birthDate', 'infos.footSize'],
    value: '',
  };
  private previousKeyword: string | null = null;
  private pending = false;
  private lock = false;
  private delay: TSyncableTableWithDelay['delay'] = {
    config: 400,
    timeout: undefined,
  };
  private error: Error | null = null;

  @Watch('search.value')
  private async onSearchChange(newValue: any) {
    if (!newValue) return;
    // Set "loading" flag
    this.pending = true;
    // Clear previous timeout
    if (this.delay.timeout) clearTimeout(this.delay.timeout);

    if (this.search.value?.length) {
      this.delay.timeout = setTimeout(() => {
        return this.searchPatient(newValue);
      }, this.delay.config);
    } else if (!this.selectedPatient) {
      return this.searchPatient(newValue);
    }
  }

  private async searchPatient(keyword: any) {
    const query = {} as any;
    // If search is available...
    if (keyword?.length) {
      query['$or'] = this.search.fields.map((x) => {
        if (x === 'infos.footSize') {
          return {
            [x]: parseFloat(keyword) || 0,
          };
        }
        if (x === 'infos.birthDate') {
          return {
            [x]: '',
          };
        }
        return {
          [x]: {
            $regex: `(.*)${keyword}(.*)`,
            $options: 'i',
          },
        };
      });
    }

    try {
      // Set "loading" flag
      this.pending = true;
      // Try to search patients...
      const response = await this.$pdc.entities!.patients.search(keyword, { query, replace: false });
      // Analytics
      /*this.$pdc.analytics?.actions.trackSuccess(
        'Navbar Patient Search',
        {
          keyword
        },
        {
          keyword: this.previousKeyword
        }
      );*/
      // Save keyword
      this.previousKeyword = keyword;
      // Set 'patients' array (exclude current patient)
      this.patients = response.data.filter((x: any) => x._id !== this.$route.params.id);
    } catch (e) {
      // Analytics
      /*this.$pdc.analytics?.actions.trackFailure(
        'Navbar Patient Search',
        e,
        {
          keyword
        },
        {
          keyword: this.previousKeyword
        }
      );*/
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset "loading" flag
      this.pending = false;
    }
  }

  @Watch('selectedPatient')
  async onSelectedPatientChanged(patientId: string) {
    // Avoid empty id
    if (!patientId) return;
    // if (this.$route.name === 'patient' && patientId === this.$route.params.id) return;
    // Set 'lock' flag
    this.lock = true;
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Patient Searched', {
      patientId,
    });
    // Redirect to patient...
    await this.$router.push({ name: 'patient', params: { id: patientId } }, this.clear);
  }

  clear() {
    // Clear timeout
    if (this.delay.timeout) clearTimeout(this.delay.timeout);

    this.$nextTick(() => {
      // Reset 'pending' flag
      this.pending = false;
      // Reset 'lock' flag
      this.lock = false;
      // Clear 'patients'
      // this.patients = [];
      // Clear 'selectedPatient'
      this.selectedPatient = null;
    });
  }
}
